
import React from "react";
import {LoadingModal} from "../../../model/http_loading";
import {useWait} from "../../../utils/wait_fn";
import styled from "styled-components";
import nsureImage from "../../../assets/imgs/logo_nsure.png"
import {useForm} from "react-hook-form";
import {InputWidget} from "../../../widget/pub/input";
import {ApproveStyle, IsApprove} from "../../../widget/pub/pub";
import {useWeb3} from "../../../provider/web3_provider";
import {NSURE, TokenInterFace} from "../../../web3/token.config";
import {getBalanceNumber} from "../../../utils/formatBalance";
import BigNumber from "bignumber.js";
import {SuccessWidget} from "../../personal/arbitration/success_widget";

export const PayModal: React.FC<{ confirmationFn: Function,buttonText:string, onDismiss?: any,biggest:BigNumber }> = ({confirmationFn,buttonText,biggest, onDismiss}) => {
    const {request, status, data} = useWait(confirmationFn);
    const {tokenMap} = useWeb3();
    const {register, handleSubmit, setValue, errors} = useForm();
    let _max = getBalanceNumber(biggest)
    return (
        <LoadingModal success={SuccessWidget} status={status} onDismiss={onDismiss} data={data}>
            <DepositStyle>
                <img src={nsureImage} alt=""/>
                <TopStyle>
                    Claim Pay
                </TopStyle>
                <MainStyle>
                    
                    <form>
                        <InputWidget

                            label={''}
                            placeholder={"Input"}
                            name={'amount'}
                            errors={errors}
                            inputRef={register({
                                required: 'no Enter the number is dame',
                                max: {value: _max, message: 'Enter the number'},
                            })}
                        />
                    </form>

                    <ApproveStyle onClick={handleSubmit((ev) => {
                        let _amount = ev.amount;
                        // if(_amount <=0) return ;
                        if (_amount == _max) {
                            request(biggest);
                            return ''
                        }
                        request(new BigNumber(_amount).times(1e18));
                    })} className={'button'}>{buttonText}</ApproveStyle>


                </MainStyle>

            </DepositStyle>
        </LoadingModal>
    );
}

const MainStyle = styled.div`
  border-radius: 0 0 5px 5px;
  padding: 20px 30px;
  box-sizing: border-box;
  background-color: #FFFFFF;

  .box {
    height: 118px;
    background: #EFEFF6;
    border: 1px solid #E1E1E9;
    border-radius: 4px;
    padding: 30px 0 35px 0;
    box-sizing: border-box;
    text-align: center;

    h2 {
      font-size: 14px;
      font-weight: 400;
      color: #1C093A;
      line-height: 18px;
    }

    h3 {
      margin-top: 18px;
      font-size: 36px;
      font-weight: 400;
      color: #1C093A;
      line-height: 18px;
    }
  }

  form {
    margin-bottom: 20px;
  }

`
const TopStyle = styled.div`
  background-color: #EFEFF6;
  height: 80px;
  border-radius: 5px 5px 0 0;
  padding-top: 40px;
  box-sizing: border-box;
  text-align: center;

  font-size: 18px;
  font-weight: 600;
  color: #270d4f;
`;
const DepositStyle = styled.div`
  width: 400px;
  border-radius: 5px;

  img {
    display: block;
    width: 90px;
    height: 90px;
    margin: 0 auto;
    margin-bottom: -45px;
  }
`
